<script setup lang="ts">
    import { useSlots } from 'vue';
    import EchoPopover from './EchoPopover.vue';
    import IconButton from './IconButton.vue';
    import { __ } from '../stores/expressions';
    import { InfoIcon } from '@lucide/vue';

    const props = withDefaults(
        defineProps<{
            headerTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
            helpHint?: string;
        }>(),
        {
            headerTag: 'h3',
            helpHint: undefined,
        }
    );

    const slots = useSlots();
</script>

<template>
    <div>
        <EchoPopover type="text">
            <template #button="{ anchor, togglePopover, buttonAttrs }">
                <component
                    :is="props.headerTag"
                    v-if="slots.header"
                    class="text-overline mb-1 flex items-start"
                >
                    <slot name="header" />

                    <div class="ml-1.5">
                        <div class="-m-0.5">
                            <IconButton
                                v-if="slots.help"
                                :ref="anchor"
                                :tooltip="helpHint"
                                size="size-5"
                                area-size="size-6"
                                :aria-label="__('show-info')"
                                v-bind="buttonAttrs"
                                @click="togglePopover"
                            >
                                <InfoIcon class="size-5" />
                            </IconButton>
                        </div>
                    </div>
                </component>
            </template>

            <template #popover>
                <slot name="help" />
            </template>
        </EchoPopover>

        <div class="flex flex-col gap-6">
            <slot />
        </div>
    </div>
</template>
